import { createFileRoute } from '@tanstack/react-router';

type ThreadCreationSearch = {
  personPhone?: string;
  personId?: string;
  departmentId?: string;
  groupId?: string;
};

export const Route = createFileRoute('/messages/$filter/new')({
  validateSearch: (search: Partial<ThreadCreationSearch>): ThreadCreationSearch => {
    return {
      personPhone: search.personPhone,
      personId: search.personId,
      departmentId: search.departmentId,
      groupId: search.groupId,
    };
  },
});
